// extracted by mini-css-extract-plugin
export default {"container":"BookPage_container__aZoF7","title":"BookPage_title__QIwmC","header":"BookPage_header__pWFo2","slots":"BookPage_slots__Cq7y6","locations":"BookPage_locations__r6UD5"};